<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>Approve Payment</strong>           
          </div>  
          <div class="box">
             <div id="overlay" >
             <div class="loader"></div>
           </div>
               <b-card-body>
                <b-row> 
                  <b-col md="12">
                 <b-button v-if="this.totallogRows >0" @click="exportcsv"  size="md" variant="primary" style="float:right;">Export</b-button>
                 
                 </b-col>
               </b-row>
             </b-card-body>
             <!-- <b-row> -->
                  <b-col sm="12" >
                 
              <b-table show-empty stacked="md" striped hover :items="openticketitems" :fields="openticketfields"  :isBusy="isBusyticket" :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" caption-top>
          <!-- <b-table show-empty stacked="md"  :items="openticketitems" :busy="isBusy"  :fields="openticketfields" :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" >  -->

            <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
            </div>  
             <template slot="table-caption"><b>Open Ticket</b>
               <p style="float:right"> <b>Total Records :<span style="color:red;">{{totalRowsticket}}</span></b> </p>
             </template>
            <template slot="actions" slot-scope="row">
             <i v-b-tooltip.hover title="Approve" @click="changeStatus(1,row.item.id)" class="fa fa-check" aria-hidden="true" style=" color: green;" ></i>
              &nbsp;
            <i v-b-tooltip.hover title="Reject" @click="changeStatus(2,row.item.id)" class="fa fa-times" aria-hidden="true" style="color: red" ></i> 
                </template>

        
          </b-table>
        </b-col>
      <!-- </b-row> -->

            <!-- <b-col sm="12" >
               <p style="float:right"> <b>Total Records :<span style="color:red;">{{totallogRows}}</span></b> </p>
             </b-col> -->
       <!-- <b-row> -->
        <b-col sm="12" >       
        <b-table show-empty stacked="md" striped hover :items="logitems" :fields="logfields"  :current-page="currentPagelog"   :per-page="perPagelog" :isBusy="isBusylog" :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" caption-top>
           <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
            </div> 
              <template slot="table-caption"><b>Logs</b>  
                <p style="float:right"> <b>Total Records :<span style="color:red;">{{totallogRows}}</span></b> </p>
              </template>
               <template slot="status" slot-scope="row">
                {{ row.item.status ==1?'Approved':'Rejected'}}
               </template>
        </b-table>
      </b-col>
      <!-- </b-row> -->
      <b-col md="12" class="my-1 " v-if="this.totallogRows > 20">
            <b-pagination
                v-model="currentPagelog"
                :total-rows="totallogRows"
                :per-page="perPagelog"
                class="my-0"
              ></b-pagination>
          </b-col>  
         
          </div>
        </b-card>
      </b-col>       
    </b-row>
  </div>
</template>
<style>
.notification.is-success {
      background-color: green!important;
      width: 400px;
}
</style>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
import vSelect from 'vue-select'
Vue.component('v-select', vSelect)
export default {
  data: function() {
    return {
      logdata: [],
      ticketdata: [],
      isBusyticket:false,
      totalRowsticket:0,

      openticketitems:[],
      openticketfields:[
       { key: 'user_name', label: 'User Name', sortable: true, sortDirection: 'desc' },
       { key: 'receipt_no', label: 'Receipt NO', sortable: true, sortDirection: 'desc' },
       { key: 'ridername', label: 'Rider Name', sortable: true, sortDirection: 'desc' },
          { key: 'deposit_amount', label: 'Deposited Amount', sortable: true, sortDirection: 'desc' },
           { key: 'payment_mode', label: 'Mode Of Payment', sortable: true, sortDirection: 'desc' },
          { key: 'created_date', label: 'Created Date', sortable: true},
          
          { key: 'actions', label: 'Actions' },
      ],
      currentPagelog:1,
      perPagelog:20,
      totallogRows:0,
       pageOptions: [5, 10, 15],
        sortBy: null,
      isBusylog:false,
      bordered: true,
      logitems:[],
      logfields:[
       { key: 'user_name', label: 'User Name', sortable: true, sortDirection: 'desc' },
       { key: 'receipt_no', label: 'Receipt NO', sortable: true, sortDirection: 'desc' },
       { key: 'ridername', label: 'Rider Name', sortable: true, sortDirection: 'desc' },
          { key: 'deposit_amount', label: 'Deposited Amount', sortable: true, sortDirection: 'desc' },
           { key: 'created_date', label: 'Created Date', sortable: true},
           { key: 'payment_mode', label: 'Mode Of Payment', sortable: true, sortDirection: 'desc' },
          
          { key: 'updated_date', label: 'Updated Date', sortable: true},
          
          { key: 'status', label: 'Status' },
           { key: 'updated_by', label: 'Updated By' },
      ],
      statusdata: [],
      toggleInfo: false,
      data1: [],
      totalRows:0,
      //totallogRows:0,
     // id: '1',
      codclosureDetails : [],
      shipmentdata:[],
      agentmaster:[],

    }
  },
  created: function() {
    this.displaylogdata()
    this.displayticketdata()
    //this.changeStatus()
  },
  methods: {


      changeStatus: function(status,status_id) {
        if(confirm("Are you sure you want to change status?")){
        var chnagedstatus = status;
        //console.log("chnagedstatus::::::::::::::",chnagedstatus);
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        var sysemailid = `${userInfo.sysemailid}`;
        var id = status_id;
         if(chnagedstatus==1){
        const statusdata = {
          status: chnagedstatus,
          sysemailid: sysemailid,
           hub_id:`${userInfo.pickuplocationmasterid}`,
          id: id,
        }
        // return false;
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/approvenotapprovedstatuslog`,statusdata)
        .then((result) => {          
          //this.approvedpaymentlog = result.body.returnvalue;  
          alert("Status Changed")   
          // this.$fire({
          //         text: "Status Changed",
          //         type: "success",
          //         timer: 30000
          //       });  
         this.displaylogdata();
         this.displayticketdata();         
        })
        .catch((ex) => {
          console.log('error', ex)
        })
        }
        if(chnagedstatus==2){
        const statusdata = {
          status: chnagedstatus,
          sysemailid: sysemailid,
           hub_id:`${userInfo.pickuplocationmasterid}`,
          id: id,
        }
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/approvenotapprovedstatuslog`,statusdata)
        .then((result) => {          
          //this.approvedpaymentlog = result.body.returnvalue;  
          alert("Status Changed")  
          // this.$fire({
          //         text: "Status Changed",
          //         type: "success",
          //         timer: 30000
          //       });  
          this.displaylogdata();
          this.displayticketdata();             
        })
        .catch((ex) => {
          console.log('error', ex)
        })
        }
                  
     }
  },

  // Function to Export CSV
  exportcsv:function(){
     document.getElementById("overlay").style.display = "block";
     var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata) 
      const csvObj = {
        hub_id:`${userInfo.pickuplocationmasterid}`,
       sysusermasterid:`${userInfo.sysusermasterid}`,  
        is_finance_superadmin:`${userInfo.is_finance_superadmin}`,
          };
          // console.log("csvobj",csvObj);
          // return false;
this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/approvedpaymentlogcsv`,csvObj)
        .then(result => {
         // console.log(result);
          document.getElementById("overlay").style.display = "none";
          if(result.body=="success")
         {
         alert("Please Check Your Mail For Downlod Link")
          // this.$fire({
          //         text:"Please Check Your Mail For Downlod Link",
          //         type: "success",
          //         timer: 30000
          //       }); 
       }
       else
       {
        alert("Can not Download");
          // this.$fire({
          //         text:"Can not Download",
          //         type: "error",
          //         timer: 30000
          //       }); 
       }
        
        });
  },

    displayticketdata: function() {
      this.isBusyticket = true;
        var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
       var ticketObj = {
         hub_id:`${userInfo.pickuplocationmasterid}`,
         is_finance_superadmin:`${userInfo.is_finance_superadmin}`,
      };
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/approvedpaymentopenticket`,ticketObj)
        .then((result) => {
          if (result.body.returnmsg=="Successful") {
          
          this.openticketitems=result.body.returnvalue;
          // console.log("Opentickets",this.openticketitems);
         this.totalRowsticket = result.body.returnvalue.length;
          this.isBusyticket = !this.isBusyticket
        }
       
          else{
             this.totalRowsticket=0;
            this.openticketitems=[];
           this.isBusyticket = false;
         }
        
        })
        .catch((ex) => {
          console.log('error', ex)
        })
    },
     displaylogdata: function(deliveryagentid){
      this.isBusylog=true;
       var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
       var displayObj = {
         hub_id:`${userInfo.pickuplocationmasterid}`,
         is_finance_superadmin:`${userInfo.is_finance_superadmin}`,
      };
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/approvedpaymentlog`,displayObj)
        .then((result) => {
          if (result.body.returnmsg=="Successful") {
          this.logitems=result.body.returnvalue;
          // console.log("Log",this.logitems);
          this.totallogRows = result.body.returnvalue.length;
          this.isBusylog = !this.isBusylog
        }
        else{
          this.logitems=[];
          this.totallogRows=0;
           this.isBusylog = false;
        }
        })
        .catch((ex) => {
          console.log('error', ex)
        })
    },
  }
};
</script>
<style type="text/css">
  .record{
    text-align: center;
  }
</style>

